import { render, staticRenderFns } from "./OrderItemsEditor.vue?vue&type=template&id=a5d3c892&"
import script from "./OrderItemsEditor.vue?vue&type=script&lang=js&"
export * from "./OrderItemsEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports